<template>
  <v-form ref="userEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'user-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col>
        <v-tabs v-model="tab">
          <v-tab>Инфо</v-tab>
          <v-tab :disabled="!user.id">Пароль</v-tab>
          <v-tab :disabled="!user.id">Бонусы</v-tab>
          <v-tab :disabled="!user.id">Заказы</v-tab>
          <v-tab :disabled="!user.id">Адреса</v-tab>
          <v-tab :disabled="!user.id">Промокоды</v-tab>
          <v-tab :disabled="!user.id">Отзывы</v-tab>
          <v-tab :disabled="!user.id">Любимые блюда</v-tab>
          <v-tab :disabled="!user.id">Iiko</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pt-8">
          <v-tab-item>
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                        v-model="user.name"
                        outlined
                        label="Имя"
                        :rules="[rules.required]"
                        required
                ></v-text-field>
                <v-row>
                  <v-col class="pt-0 pb-0">
                    <v-text-field
                            v-model="user.phone"
                            outlined
                            label="Телефон"
                            :rules="[rules.required]"
                            required
                    ></v-text-field>
                  </v-col>
                  <v-col class="pt-0 pb-0">
                    <v-text-field
                            v-model="user.birthday"
                            outlined
                            label="День рождения"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-text-field
                        v-model="user.facebook"
                        outlined
                        label="Facebook"
                ></v-text-field>

                <v-checkbox
                        v-model="user.blocked"
                        outlined
                        label="Заблокирован"
                ></v-checkbox>

                <v-checkbox
                        v-model="user.no_cash_payment"
                        outlined
                        label="Нельзя расплачиваться наличкой"
                ></v-checkbox>
                <v-text-field
                        v-model="user.email"
                        outlined
                        label="Почта"
                ></v-text-field>
                <v-textarea
                        label="Комментарий"
                        v-model="user.comment"
                        rows="3"
                        outlined
                ></v-textarea>


                <v-select
                    :items="roles"
                    :item-text="role => role.name"
                    :item-value="role => role.slug"
                    v-model="user.role"
                    outlined
                    label="Роль"
                ></v-select>
                <v-btn :loading="loadingButton" @click="update" v-if="user.id">Сохранить</v-btn>
              </v-col>
              <v-col cols="12" sm="1" md="1" class="text-center d-none-xs">
                <v-divider vertical></v-divider>
              </v-col>
              <v-col cols="12" sm="2" md="1">
                <v-img :src="previewImage(avatarImage)" aspect-ratio="1">
                  <template v-slot:placeholder>
                    <div class="image-placeholder"></div>
                  </template>
                </v-img>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <password-tab v-model="user" :loading="loading"></password-tab>
          </v-tab-item>
          <v-tab-item>
            <bonus-tab v-model="user" :loading="loading"></bonus-tab>
          </v-tab-item>
          <v-tab-item>
            <order-tab v-model="user" :loading="loading"></order-tab>
          </v-tab-item>
          <v-tab-item>
            <address-tab v-model="user" ></address-tab>
          </v-tab-item>
          <v-tab-item>
            <promocode-tab v-model="user"></promocode-tab>
          </v-tab-item>
          <v-tab-item>
            <review-tab v-model="user" :loading="loading"></review-tab>
          </v-tab-item>
          <v-tab-item>
            <favorite-tab v-model="user" :loading="loading"> </favorite-tab>
          </v-tab-item>
          <v-tab-item>
            <iiko-tab v-model="user"></iiko-tab>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import UserService from './../../api/UserService'
  import BonusTab from './Tables/Bonus'
  import PasswordTab from './Tables/Password'
  import OrderTab from './Tables/Order'
  import AddressTab from './Tables/Address'
  import FavoriteTab from './Tables/Favorite'
  import ReviewTab from './Tables/Review'
  import PromocodeTab from './Tables/Promocode'
  import IikoTab from './Tables/Iiko'
  import RoleService from "@/api/RoleService";

  export default {
    name: 'UserEdit',
    props: {
      id: String|Number
    },
    components: {BonusTab, OrderTab, AddressTab, FavoriteTab, ReviewTab, PromocodeTab, IikoTab, PasswordTab},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      tab: '',
      tabLang: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      user: {
        name: '',
        birthday: '',
        phone: '',
        facebook: '',
        email: '',
        comment: '',
        blocked: false,
        no_cash_payment: false,
      },
      roles: [],
      avatarImage: null,
      loading: true,
      loadingButton: false,
    }),
    mounted() {
      this.init();
    },
    methods: {
      validate () {
        this.$refs.userEditForm.validate()
      },
      init(){
          UserService.get(this.id)
            .then(response => {
              this.user = response.data;
              this.user.blocked = !!this.user.blocked;
              if(this.user.avatar){
                this.avatarImage = this.user.avatar;
                this.avatarImage.name = this.user.avatar.file
              }
              this.loading = false
            });
          RoleService.list({}).then(res => {
            this.roles = res.data.roles;
          });
      },
      previewImage( image) {
        if(this.avatarImage && this.avatarImage.url){
          return this.avatarImage.url
        }

      if(image){
        return URL.createObjectURL(image)
      }

      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        UserService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Пользователь успешно обновлено';
          this.snackbarColor = 'success';
        }).catch(error => {

          this.snackbar = true;
          this.snackbarText = error?.response?.data === 'cannot edit not user role' ?
              'Невозможно изменить роль' :
              'Ошибка при обновлении пользователя';
          this.snackbarColor = 'error';
        }).finally(() => (this.loadingButton = false))
      },
      getData() {
        let formData = new FormData();

        formData.append('id', this.user.id);
        formData.append('name', this.user.name);
        formData.append('birthday', this.user.birthday);
        formData.append('facebook', this.user.facebook);
        formData.append('comment', this.user.comment);
        formData.append('email', this.user.email ?? '');
        formData.append('phone', this.user.phone);
        formData.append('role', this.user.role);
        formData.append('blocked', this.user.blocked ? (new Date()).toISOString().split('.')[0].replace('T', ' ') : '');
        formData.append('no_cash_payment', !!this.user.no_cash_payment ? 1 : 0);
        formData.append('fromAdmin', true);

        return formData
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
</style>
